/** 
 *   订货管理 api
 */
import { get, post, del, put } from '@/untils/axios.js'

 // 海关盘点
export const customs     = params       => post('inventory/addcustoms', params)
// 海关盘点   0 海关盘点数据  1 盘点列表 
export const customs_get = (id,params)  => get(`inventory/customs/${id}`, params)
// 海关盘点  删除
export const customs_del = params       => del(`inventory/delcustoms`, params)
// 海关盘点确认
export const customs_ok  = params       => post(`inventory/confirmcustoms`, params)
// 加拿大盘点   0 盘点数据  1 盘点列表 
export const canada_get  = (id,params)  => get(`inventory/canada/${id}`, params)
// 加拿大盘点
export const canada      = params       => post(`inventory/addcanada`, params)
// 加拿大盘点  删除
export const canada_del = id            => del(`inventory/delcanada/${id}`)
// 加拿大盘点确认
export const canada_ok   = params       => post(`inventory/confirmcanada`, params)
// 加拿大盘点   0 盘点数据  1 盘点列表 
export const unusual     = params       => get(`inventory/abnormallist`, params)
// 备注
export const abnormal_update     = (id, params)       => post(`inventory/abnormal-update/${id}`, params)

/*
 *   订单出库
 */



// 充值订单物流
export const reset_choose = params => post('order/reset-choose-logistics', params)

// 订单eShipper 运费
export const estimated_freight = params => get('order/get-estimated-freight', params)

// 商品 出库列表
export const out_list    = params  => get('order/outlist', params)

// 商品 扫码出库
export const out_scan    = params  => get(`order/codeout/${params}`, )

// 商品 待打包列表
export const pack_list   = params  => get(`order/tobepacked`, params)

//  待打包订单 选择物流
export const logistics   = params  => post(`order/chooselogistics`, params)

//  打印物流单并处理订单
export const packed      = params  => post(`order/pack/${params}`)

//  获取运单
export const print       = params  => get(`order/getwaybill/${params}`)

// 已打包列表
export const packed_list = params  => get(`order/pack/list`, params)

// 确认发货
export const order_send  = params  => get(`order/confirmshipment/${params}`)

// 确认发货
export const order_done  = params  => get(`order/confirmservice/${params}`)

/*
 *   商品库存
 */

 // 自营库存列表
export const stock_list = (params)  => get(`/goods-sku-stock/list`,params)

// 库存操作
export const stock_updata = (id,params)  => put(`/goods-sku-stock/update/${id}`,params)

// 查看商品轨迹
export const sku_stock = params => get('/goods-sku-stock/record',params)


/*
 * 返货入库 
*/

// 售后列表
export const aftersale_list = params => get('/aftersale/returnlist', params)

// 售后商品操作
export const aftersale_back = params => post('/aftersale/returnhandle', params)

// 售后商品拒绝
export const  return_refuse = params => post('/aftersale/return-refuse', params)

// 售后列表返货
export const return_list = params => get('/aftersale/returnlist', params)

// 售后反残返货列表
export const returned_list = params => get('/aftersale/returned-list', params)

// 重新打印
export const repeat_packed = order_id => get(`order/print/waybill/${order_id}`)